import { useMemo } from 'react';

import { EnrichedCustomer, EnrichedDCConfig, EnrichedLocation } from '@/models/EnrichedPrismicDocuments.ts';

import { useConfigStore } from '@/stores/configStore.ts';

interface ConfigHook {
    customer_id: string;
    selected_location: EnrichedLocation;
    selected_customer: EnrichedCustomer;
    configs: EnrichedDCConfig[];
    config_map: Map<string, EnrichedDCConfig>;
    config_record: Record<string, EnrichedDCConfig>;
    instance_ids: string[];
    getInstanceConfig: (instance_id: string) => EnrichedDCConfig | undefined;
    location_key: string;
}

const useConfig = (): ConfigHook => {
    const { selected_location, selected_customer } = useConfigStore();

    const getInstanceConfig = (instance_id: string): EnrichedDCConfig | undefined => {
        const config = selected_location?.config_record[instance_id];
        return config;
    };

    const { configs, config_map, config_record, instance_ids, location_key } = useMemo(() => {
        if (!selected_location) {
            return {
                configs: [],
                config_map: new Map<string, EnrichedDCConfig>(),
                config_record: {},
                instance_ids: [],
                location_key: '',
            };
        }

        return {
            configs: selected_location.configs,
            config_map: selected_location.config_map,
            config_record: selected_location.config_record,
            instance_ids: selected_location.instance_ids,
            location_key: selected_location.key,
        };
    }, [selected_location]);

    return {
        customer_id: selected_customer?.customer_id ?? '',
        selected_location: selected_location!,
        selected_customer: selected_customer!,
        configs: configs,
        config_map: config_map,
        config_record: config_record,
        instance_ids: instance_ids,
        location_key: location_key,
        getInstanceConfig: getInstanceConfig,
    };
};

export default useConfig;
